import angular from 'angular'
import coreModule from '../core'
import lostPasswordComponent from './lost-password.component'
import lostPasswordRouteConfigBlock from './lost-password.route'

export default angular
  .module('app.lostPassword', [coreModule])
  .config(lostPasswordRouteConfigBlock)
  .component('elLostPassword', lostPasswordComponent)
